var loadButton = document.querySelector('#loader');

if (loadButton) {
    var count = parseInt(loadButton.getAttribute('data-count'));
    var skip = parseInt(loadButton.getAttribute('data-skip'));
    var size = parseInt(loadButton.getAttribute('data-size'));
    var category = parseInt(loadButton.getAttribute('data-category'));

    if (skip < count) {
        // loadButton.parentElement.removeChild(loadButton);
        loadButton.classList.remove('hide');
        // } else {
        loadButton.addEventListener('click', function (e) {

            loadButton.setAttribute('disabled', 'disabled');
            loadButton.innerHTML = 'Loading...';

            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // https://www.thereformedprogrammer.net/asp-net-core-razor-pages-how-to-implement-ajax-requests/
            var request = new XMLHttpRequest();
            var url = loadButton.getAttribute('data-page') + "?handler=Load";
            var params = 'skip=' + skip + '&category=' + category;

            request.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    addItems(this.responseText);
                }
            };

            request.open("POST", url, true);
            request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            request.setRequestHeader('RequestVerificationToken',
                document.querySelector('input[name="__RequestVerificationToken"]').value
            );

            request.send(params);

            function addItems(items) {
                var list = document.querySelector('#list');
                list.innerHTML += items;

                skip += size;
                loadButton.setAttribute('data-skip', skip);

                if (skip >= count) {
                    loadButton.parentElement.removeChild(loadButton);
                } else {
                    loadButton.removeAttribute('disabled');
                    loadButton.innerHTML = 'Load More';
                }
            }

            // request.setRequestHeader('Authorization', 'Bearer ' + access_token);
            // request.setRequestHeader("Content-type", "application/json;charset=UTF-8");

            //var data = {
            //    'skip': 10,
            //    'category': 20
            //};

            // request.send(JSON.stringify(data));
        });
    }
}